import React from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';

import Button from '../../../../Buttons/Button';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';
import Reviews from '../../../../../pages/app-insights/_shared/components/Reviews';
import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';

import { permissionsSelector, quickViewDataSelector } from '../../../selectors';
import links from '../../../configs/links';
import { numberToHumanChart } from '../../../../../utils/formatter';

import { sentimentsCount } from '../../../configs';

const reviewsList = [
  {
    type: 'sentiment',
    title: 'Sentiment',
    description: 'How are users reacting to this app?',
  },
  {
    type: 'intent',
    title: 'Intent',
    description: 'What are users talking about?',
  },
];

const ReviewAnalysis = ({ store, ref_no, settings }) => {
  const data = useSelector(quickViewDataSelector);
  const permissions = useSelector(permissionsSelector);

  const sentiments = get(data, 'audience.sentiments', []);
  const intents = get(data, 'audience.intents', []);
  const sentimentsCountValue = sentimentsCount(sentiments);

  const { error } = settings;
  if (error) return <ErrorStateWithReload />;

  return (
    <InsightsCardBox
      headerLeft={(
        <div className="d-flex flex-column">
          <div className="paragraph">
            Review Analysis
          </div>
          <p className="paragraph-sm" style={{ color: '#5D6B85' }}>{`Based on ${numberToHumanChart(sentimentsCountValue, { precision: 2 })} Reviews`}</p>
        </div>
      )}
      headerRight={permissions.allowReviewsAppInsights && (
        <Button variant="secondary" size="sm" href={links.sentiments(store, ref_no)}>
          Go to Review
        </Button>
      )}
      bodyMinHeight={220}
      className="review-section"
    >
      <Reviews
        sentiments={sentiments}
        intents={intents}
        reviewsList={reviewsList}
        isPending={settings.pending}
        isLoaded={!settings.pending}
      />
    </InsightsCardBox>
  );
};

ReviewAnalysis.propTypes = {
  store: T.string,
  ref_no: T.oneOfType([T.string, T.number]),
  settings: T.object,
};

export default ReviewAnalysis;
